import { render, staticRenderFns } from "./operatorinfo.vue?vue&type=template&id=4668155a"
import script from "./operatorinfo.vue?vue&type=script&lang=js"
export * from "./operatorinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports